var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-md-12" }, [
    _vm._v("\n  " + _vm._s(_vm.getConfirmBoxResponse) + "\n  "),
    _c("div", { staticClass: "row rt-menu-100" }, [
      _c("div", { staticClass: "col-md-12 pl-0 mart-10" }, [
        _vm.isAbhaEnabled && _vm.documents && _vm.documents.length
          ? _c("div", { staticClass: "col-md-12 pr-0 uploaded-images" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("ABHA Health Records"),
              ]),
              _c(
                "div",
                { staticClass: "images-box" },
                [
                  _vm._m(0),
                  _vm._l(_vm.documents, function (doc, idx) {
                    return _c(
                      "div",
                      { key: idx, staticClass: "image-list-name" },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-lg-5" }, [
                            _vm._v(
                              _vm._s(
                                doc.fileName.substring(
                                  doc.fileName.indexOf("_") + 1
                                ) || "Health Document"
                              )
                            ),
                          ]),
                          _c("div", { staticClass: "col-lg-4" }, [
                            _vm._v(
                              _vm._s(
                                _vm.formatDate(
                                  doc.date ||
                                    doc.document_date ||
                                    doc.created_date
                                )
                              )
                            ),
                          ]),
                          _c("div", { staticClass: "col-lg-3" }, [
                            _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.openFile(doc.s3Key)
                                  },
                                },
                              },
                              [_vm._v("View")]
                            ),
                          ]),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              ),
            ])
          : _vm._e(),
        _vm.isAbhaEnabled && _vm.showspinner
          ? _c("div", { staticClass: "col-md-12 text-center" }, [
              _c("span", [_vm._v("Loading health records...")]),
            ])
          : _vm._e(),
        _vm.ImageUploadedlist && _vm.ImageUploadedlist.length
          ? _c(
              "div",
              { staticClass: "col-md-12 pr-0 uploaded-images" },
              [
                _c("label", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.$t("UploadHistory"))),
                ]),
                _vm._l(_vm.ImageUploadedlist, function (item) {
                  return _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-12" }, [
                      _c(
                        "div",
                        { staticClass: "images-box" },
                        [
                          _vm._m(1, true),
                          _vm._l(item.values, function (it, index) {
                            return _c(
                              "div",
                              { staticClass: "image-list-name" },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-lg-3" }, [
                                    _c(
                                      "a",
                                      {
                                        style: !(
                                          it.image_name &&
                                          it.image_name.indexOf("pdf") == -1
                                        )
                                          ? "padding:11px;"
                                          : "",
                                        attrs: { href: _vm.getdownloadfileUrl },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.viewFile(
                                              it.report_file_key,
                                              "file"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        it.image_name &&
                                        it.image_name.indexOf("pdf") == -1
                                          ? _c("span", [
                                              _c("img", {
                                                attrs: { src: it.imageUrl },
                                              }),
                                            ])
                                          : _c("span", {
                                              staticClass:
                                                "media-left docupld-icon",
                                            }),
                                      ]
                                    ),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "image-name ",
                                        attrs: { href: _vm.getdownloadfileUrl },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.viewFile(
                                              it.report_file_key,
                                              "file"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(it.image_name) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  item.key
                                    ? _c("div", { staticClass: "col-lg-2" }, [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(item.key) +
                                            "\n                  "
                                        ),
                                      ])
                                    : _c("div", { staticClass: "col-lg-2" }, [
                                        _vm._v(
                                          "\n                    N/A\n                  "
                                        ),
                                      ]),
                                  _c("div", { staticClass: "col-lg-2" }, [
                                    _c("span"),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(it.visit_date) +
                                        "\n                  "
                                    ),
                                  ]),
                                  _c("div", { staticClass: "col-lg-2" }, [
                                    _c("span"),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.formatTime(
                                            it.uploaded_date,
                                            false
                                          )
                                        ) +
                                        "\n                  "
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "col-lg-2 image-date" },
                                    [
                                      _c("span", { staticClass: "time-field" }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.formatTime(
                                              it.uploaded_date,
                                              true
                                            )
                                          ) +
                                          "\n                  "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
                  ])
                }),
              ],
              2
            )
          : _c("div", { staticClass: "col-md-12 pr-0 uploaded-images" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v(_vm._s(_vm.$t("UploadedFiles"))),
              ]),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c(
                    "div",
                    {
                      staticClass: "images-box center-text",
                      staticStyle: { "text-align": "center" },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("NoFileHasBeenUploaded")) +
                          "\n            "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "image-head" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-5 full-left visit-secton" }, [
          _c("strong", [_vm._v("Document")]),
        ]),
        _c("div", { staticClass: "col-lg-4" }, [
          _c("strong", [_vm._v("Date")]),
        ]),
        _c("div", { staticClass: "col-lg-3" }, [
          _c("strong", [_vm._v("Action")]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "image-head" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-3 full-left visit-secton" }, [
          _c("strong", [_vm._v("File")]),
        ]),
        _c("div", { staticClass: "col-lg-2 full-left visit-secton" }, [
          _c("strong", [_vm._v("Visit ID")]),
        ]),
        _c("div", { staticClass: "col-lg-2" }, [
          _c("strong", [_vm._v(" Visit date")]),
        ]),
        _c("div", { staticClass: "col-lg-2" }, [
          _c("strong", [_vm._v(" Uploaded date ")]),
        ]),
        _c("div", { staticClass: "col-lg-2" }, [
          _c("strong", [_vm._v(" Uploaded time ")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }